<template>
    <vue-html2pdf :enable-download="true" :paginate-elements-by-height="1400" :filename="currentFilename" :pdf-quality="2"
        :manual-pagination="true" pdf-format="a4" :pdf-orientation="orientation" pdf-content-width="100%" ref="html2Pdf">
        <section slot="pdf-content">
            <section v-for="(group, groupIndex) in groupedDesserts" :key="groupIndex">
                <section>
                    <div class="header">
                        <div class="column logo">
                            <img class="topbar-logo" src="../assets/logo-giser.png" alt="Giser Uniformes" />
                        </div>
                        <div class="column title">
                            <h3>{{ title}}</h3>
                        </div>
                        <div class="column date-time">
                            <span id="datetime">
                                <p>Fecha: {{ inf }}</p>
                                <p>Pag: {{ groupIndex+1 }} / {{ groupedDesserts.length }}</p>
                                <p v-if="totalBatches > 1">Lote: {{ currentBatch }} / {{ totalBatches }}</p>
                            </span>
                        </div>
                    </div>
                </section>
                <hr>
                <v-data-table :headers="headers" :items="group" hide-default-footer :items-per-page=-1
                    class="elevation-1 custom-font">
                </v-data-table>
                <div v-if="showSignature">
                    <hr>
                    <div class="firma-container">
                        <div class="linea-firma"></div>
                        <div class="nombre-firma">Nombre Rut y Firma</div>
                    </div>
                </div>
                <div v-if="groupIndex+1 < groupedDesserts.length" class="html2pdf__page-break" />
            </section>
        </section>
    </vue-html2pdf>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
export default {
    name: 'ReportDataPdfBasic',
    components: {
        VueHtml2pdf,
    },
    props: {
        name: String,
        title: String,
        elementsPerPag: Number,
        headerAll: Boolean,
        showSignature: {
            type: Boolean,
            default: false
        },
        inf: String,
        headers: {
            type: Array, default: () => []
        },
        items: {
            type: Array, default: () => []
        },
        orientation: {
            type: String, default: () => 'portrait'
        },
        batchSize: {
            type: Number,
            default: 400
        }
    },
    data: () => ({
        itemsToRender: [],
        currentBatch: 0,
        totalBatches: 1,
        isGenerating: false,
        currentFilename: ''
    }),
    computed: {
        groupedDesserts() {
            const items = this.itemsToRender.length > 0 ? this.itemsToRender : this.items;
            const grouped = [];
            if(this.showSignature){
                const groupedByRut = items.reduce((acc, item) => {
                const rut = item.employee.rut;
                if (!acc[rut]) {
                    acc[rut] = [];
                }
                acc[rut].push(item);
                return acc;
                }, {});
                const subArrays = Object.values(groupedByRut);
                subArrays.forEach((subArray) => {
                    for (let i = 0; i < subArray.length; i += this.elementsPerPag) {
                        grouped.push(subArray.slice(i, i + this.elementsPerPag));
                    }
                });
            } else {
                for (let i = 0; i < items.length; i += this.elementsPerPag) {
                    grouped.push(items.slice(i, i + this.elementsPerPag));
                }
            }
            return grouped;
        },
    },
    methods: {
        calculateBatches() {
            if (this.items.length <= this.batchSize) {
                return [this.items];
            }
            const batches = [];
            for (let i = 0; i < this.items.length; i += this.batchSize) {
                batches.push(this.items.slice(i, i + this.batchSize));
            }
            return batches;
        },

        async generateSinglePdf(batchItems, filename) {
            this.itemsToRender = batchItems;
            this.currentFilename = filename;
            await this.$nextTick();
            await this.delay(300);
            this.$refs.html2Pdf.generatePdf();
            await this.waitForDownload();
        },

        waitForDownload() {
            return new Promise((resolve) => {
                const handler = () => {
                    this.$refs.html2Pdf.$off('hasDownloaded', handler);
                    resolve();
                };
                this.$refs.html2Pdf.$on('hasDownloaded', handler);
            });
        },

        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        async generatePdf() {
            if (this.isGenerating) return;
            this.isGenerating = true;
            this.$emit('generation-start');

            const batches = this.calculateBatches();
            this.totalBatches = batches.length;

            try {
                for (let i = 0; i < batches.length; i++) {
                    this.currentBatch = i + 1;
                    const filename = batches.length === 1
                        ? this.name
                        : `${this.name}-${this.currentBatch}-${this.totalBatches}`;

                    await this.generateSinglePdf(batches[i], filename);

                    if (i < batches.length - 1) {
                        await this.delay(1500);
                    }
                }
            } finally {
                this.isGenerating = false;
                this.itemsToRender = [];
                this.$emit('generation-finish');
            }
        }
    },
    mounted() {
        this.currentFilename = this.name;
        console.log("activadoMounted", this.showSignature)
    }
}
</script>
<style lang="scss">
.topbar-logo {
  max-width: 150px;
}
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}
.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}
.v-text-field__details {
  display: none;
}

.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px; /* ajusta el tamaño de la fuente según tus necesidades */
  text-transform: uppercase;
}

.header {
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ccc;
}

.footer-pdf {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #333;
  color: white;
  text-align: center;
  padding: 10px;
}

.column {
  flex: 1;
}

.logo {
  text-align: left;
}

.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date-time {
  text-align: center;
}
/* Estilo para el contenedor de la firma */
.firma-container {
            margin-top: 5cm; /* Distancia de 4 cm desde el último div */
            text-align: center; /* Centrar la línea y el nombre */
        }

        /* Estilo para la línea de firma */
        .linea-firma {
            width: 200px; /* Ancho de la línea */
            border-bottom: 1px solid black; /* Línea negra */
            margin: 0 auto; /* Centrar la línea */
        }

        /* Estilo para el nombre debajo de la línea */
        .nombre-firma {
            margin-top: 10px; /* Espacio entre la línea y el nombre */
            font-family: Arial, sans-serif; /* Fuente del nombre */
            font-size: 14px; /* Tamaño de la fuente */
        }
</style>